import { render, staticRenderFns } from "./SButtonLink.vue?vue&type=template&id=22e5f893&scoped=true&"
import script from "./SButtonLink.vue?vue&type=script&lang=js&"
export * from "./SButtonLink.vue?vue&type=script&lang=js&"
import style0 from "./SButtonLink.vue?vue&type=style&index=0&id=22e5f893&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5f893",
  null
  
)

export default component.exports